import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notes-export-dialog',
  imports: [CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    MatRadioModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatRadioGroup,
    MatRadioButton,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './notes-export-dialog.component.html',
  styleUrl: './notes-export-dialog.component.scss'
})
export class NotesExportDialogComponent {
  notes: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<NotesExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { notes: boolean }
  ) {
    this.notes = data.notes;
  }

  onConfirm() {
    this.dialogRef.close(this.notes);
  }

  onCancel() {
    this.dialogRef.close(undefined);
  }
}
